/** Maps customer/caregiver nav paths to platform feature-flag keys. */

export const ROUTE_FEATURE_FLAGS = {
  "/marketplace": "marketplaceDiscoveryEnabled",
  "/hourly": "hourlyBookingsEnabled",
  "/caregiver/hourly-bookings": "hourlyBookingsEnabled",
  "/caregiver/start-end-service": "hourlyBookingsEnabled",
};

/** Maps customer nav paths to Platform Configuration visibility module ids. */
export const CUSTOMER_NAV_MODULES = {
  "/dashboard": "booking",
  "/marketplace": "booking",
  "/my-bookings": "booking",
  "/hourly": "booking",
  "/subscription": "subscription",
  "/payments": "payments",
  "/payment-history": "payments",
};

export function filterNavItemsByFeatures(items, isFeatureEnabled, options = {}) {
  if (!Array.isArray(items) || typeof isFeatureEnabled !== "function") return items || [];
  const { isModuleEnabled, role = "customer" } = options;
  return items.filter((item) => {
    const path = String(item?.to || "").split("?")[0];
    const flagKey = ROUTE_FEATURE_FLAGS[path];
    if (flagKey && !isFeatureEnabled(flagKey)) return false;
    const moduleId = CUSTOMER_NAV_MODULES[path];
    if (moduleId && typeof isModuleEnabled === "function" && !isModuleEnabled(moduleId, role)) {
      return false;
    }
    return true;
  });
}

export function isMarketplaceServiceTypeEnabled(serviceType, isFeatureEnabled) {
  if (typeof isFeatureEnabled !== "function") return true;
  if (serviceType === "hourly") return isFeatureEnabled("hourlyBookingsEnabled");
  if (serviceType === "fullTime") return isFeatureEnabled("fullTimeBookingsEnabled");
  return true;
}
